import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Drawer, Input, Form } from 'kts-xui';
import { FormInstance } from 'kts-components-antd-x4/lib/form';
import { MyStore } from 'kts-platform-frame/redux';
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onSuccess: () => void;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    formRef = React.createRef<FormInstance>();
    constructor(props: IProps) {
        super(props, ModulesAction);

    }

    openModal = () => {
        this.modulesState.showModal = true;
        this.setModulesState();
    }
    onClose = () => {
        this.modulesState.showModal = false;
        this.setModulesState();
    }
    onSubmit = () => {
        this.formRef.current.submit();
    }
    onFinish = values => {
        ModulesAction.createDid(values);
    }
    render() {
        const { user } = MyStore.instance.getState();
        return (
            <div>

                <Drawer
                    title="DID申请"
                    onClose={this.onClose}
                    visible={true}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button style={{ marginRight: 8 }} key='1' type="primary" onClick={this.onSubmit}>提交</Button>
                            <Button key='2' onClick={this.onClose}>取消</Button>
                        </div>}
                >
                    <Form
                        ref={this.formRef}
                        labelCol={null}
                        wrapperCol={null}
                        layout='vertical'
                        onFinish={this.onFinish}
                    >
                        <Form.Item
                            name="companyName"
                            label="DAP企业/机构"
                            labelCol={null}
                            wrapperCol={null}
                            initialValue={user.userInfo.companyName}
                            rules={[{ required: true, message: "字段不能为空", }]}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                        <Form.Item
                            name="agent"
                            label="代理人"
                            initialValue={user.userInfo.nickName}
                            rules={[{ required: true, message: "字段不能为空", }]}
                        >
                            <Input disabled={true} />
                        </Form.Item>
                        <Form.Item
                            name="remarkName"
                            label="DID备注名称"
                            rules={[{ required: true, message: "字段不能为空" }]}
                        >
                            <Input placeholder="" maxLength={20}/>
                        </Form.Item>
                        <Form.Item
                            name="applicationReason"
                            label="申请理由"
                        >
                            <Input.TextArea maxLength={200}/>
                        </Form.Item>
                        {/* <Form.Item >
                            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
                                提交
                            </Button>
                            <Button htmlType="button" onClick={this.onClose}>
                                取消
                            </Button>
                        </Form.Item> */}
                    </Form>
                </Drawer>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/DiDManager/UI.AddModal.tsx